module.exports = __webpack_public_path__ + "static/media/abus-cover-right.91a09e86.png";